import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormArray, FormControl, FormGroup } from '@angular/forms';
import { IDocumentData } from '@app/transaction-builder/model/document-data.model';
import {
  IDocumentSwapEvent,
  IEditSignFieldsEvent,
  IRemoveDocumentEvent,
} from '@app/transaction-builder/model/document-events.model';
import { ClientSignFieldsByDocument } from '@app/transaction-builder/model/sign-field.model';
import { ITxFormClientData } from '@app/transaction-builder/model/transaction-form-data.model';
import { TransactionBuilderStorageService } from '@app/transaction-builder/services/transaction-builder-storage.service';
import { SignatureType } from 'ngx-mat-esign360';

@Component({
  selector: 'app-document-form-section',
  templateUrl: './document-form-section.component.html',
  styleUrls: ['./document-form-section.component.scss'],
})
export class DocumentFormSectionComponent implements OnInit {
  @Input() formGroup: FormGroup;
  @Input() clients: ITxFormClientData[];
  @Input() documentsData: IDocumentData[];
  @Input() signFieldsByDocument: ClientSignFieldsByDocument;
  @Input() canUploadFiles: boolean;
  @Input() canRemoveFiles: boolean;
  @Input() canSelectDefaultSigType: boolean;
  @Input() canSelectGlobalSigType: boolean;
  @Input() canEditDocSigners: boolean;
  @Output() documentsSelected = new EventEmitter<File[]>();
  @Output() editSignFields = new EventEmitter<IEditSignFieldsEvent>();
  @Output() removeDocument = new EventEmitter<IRemoveDocumentEvent>();
  @Output() changeDefaultSigType = new EventEmitter<SignatureType>();
  @Output() changeGlobalSigType = new EventEmitter<SignatureType>();
  @Output() documentSwap = new EventEmitter<IDocumentSwapEvent>();

  get clientsToDocsFormArray(): FormArray {
    return this.formGroup.get('clientsToDocs') as FormArray;
  }

  constructor(public transactionBuilderStorage: TransactionBuilderStorageService) {}

  ngOnInit(): void {}

  onDefaultSigTypeSelect(type: SignatureType) {
    this.changeDefaultSigType.emit(type);
  }

  onGlobalSigTypeSelect(type: SignatureType) {
    this.changeGlobalSigType.emit(type);
  }

  onDocumentSwap(file: File, documentCid: string) {
    this.documentSwap.emit({
      file,
      documentCid,
    });
  }
}
